import { Progress } from "@/components/ui/progress";
import { gbp } from "./pills";

export function DailyReportStats({ summary }) {
  const due = summary.total_due_amount || 0;
  const matched = summary.total_matched_amount || 0;
  const covered = summary.covered_amount || 0;
  const rate = due > 0 ? Math.min(100, ((matched + covered) / due) * 100) : 0;
  const cells = [
    { id: "due-today", label: "Due today", value: gbp(due), sub: `${summary.total_loans_due || 0} loans scheduled`, tone: "text-slate-900" },
    { id: "received", label: "Received", value: gbp(summary.total_received_amount), sub: `${summary.total_transactions || 0} credits`, tone: "text-emerald-700" },
    { id: "matched", label: "Matched", value: gbp(matched), sub: `${summary.matched_count || 0} reconciled`, tone: "text-slate-800" },
    { id: "paid-ahead", label: "Already covered", value: gbp(covered), sub: `${summary.covered_count || 0} paid ahead / earlier`, tone: "text-sky-700" },
    { id: "still-due", label: "Still due", value: gbp(summary.outstanding_amount), sub: `${summary.unmatched_loans || 0} awaiting${summary.part_paid_count ? ` · ${summary.part_paid_count} part-paid` : ""}`, tone: "text-amber-700" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 rounded-lg border border-slate-200 bg-white shadow-sm divide-y md:divide-y-0 md:divide-x divide-slate-100" data-testid="daily-stat-strip">
      {cells.map((c) => (
        <div key={c.id} className="px-4 py-3" data-testid={`stat-${c.id}`}>
          <p className="text-[11px] uppercase tracking-wide text-slate-500">{c.label}</p>
          <p className={`font-mono text-lg sm:text-xl font-bold tabular-nums ${c.tone}`}>{c.value}</p>
          <p className="text-xs text-slate-400">{c.sub}</p>
        </div>
      ))}
      <div className="px-4 py-3" data-testid="stat-collection-rate">
        <p className="text-[11px] uppercase tracking-wide text-slate-500">Collection rate</p>
        <p className="font-mono text-lg sm:text-xl font-bold tabular-nums text-slate-900">{rate.toFixed(1)}%</p>
        <Progress value={rate} className="h-1.5 mt-1.5 bg-slate-100 [&>div]:bg-emerald-600" />
        <p className="text-[10px] text-slate-400 mt-1">matched + already covered</p>
      </div>
    </div>
  );
}
